
import { defineComponent, onMounted } from 'vue'
import { useThemeModel } from '@entities/theme'
import { AppButton } from '@shared/ui'

export default defineComponent({
  name: 'PaymentWait',
  components: { AppButton },
  emits: ['paymentWaitMethods', 'callYandexMetricGoal'],

  setup (_, { emit }) {
    const themeModel = useThemeModel()

    onMounted(() => {
      emit('callYandexMetricGoal', 'paymentWait')
    })

    return { themeModel }
  }
})
